class PawCareVariationCards extends HTMLElement {
  #abortController = new AbortController();
  #productDetails;

  connectedCallback() {
    this.#abortController = new AbortController();
    const productDetails = this.closest('.product-details');
    if (!productDetails) return;
    this.#productDetails = productDetails;

    productDetails.addEventListener('variant:update', () => this.updateSelectedCard(), {
      signal: this.#abortController.signal,
    });
    productDetails.addEventListener('change', () => this.updateSelectedCard(), {
      signal: this.#abortController.signal,
    });
    this.addEventListener('click', this.handleCardClick, { signal: this.#abortController.signal });

    this.updateSelectedCard();
  }

  disconnectedCallback() {
    this.#abortController.abort();
    this.#productDetails?.querySelectorAll('[data-pc-card-picker]').forEach((group) => {
      group.removeAttribute('data-pc-card-picker');
    });
    this.#productDetails = null;
  }

  handleCardClick = (event) => {
    const card = event.target instanceof Element ? event.target.closest('.pc-variation-card') : null;
    const optionValue = card?.getAttribute('data-option-value');
    const optionIndex = this.dataset.optionIndex;
    const picker = this.closest('.product-details')?.querySelector('variant-picker');

    if (!optionValue || optionIndex == null || !picker || card.disabled) return;

    const input = Array.from(picker.querySelectorAll('input')).find(
      (element) => element.dataset.fieldsetIndex === optionIndex && element.value === optionValue
    );

    if (input instanceof HTMLInputElement && !input.checked) input.click();

    const select = picker.querySelector(`select[data-fieldset-index="${optionIndex}"]`);
    if (select instanceof HTMLSelectElement && select.value !== optionValue) {
      select.value = optionValue;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  updateSelectedCard() {
    const optionIndex = this.dataset.optionIndex;
    const picker = this.closest('.product-details')?.querySelector('variant-picker');
    if (optionIndex == null || !picker) return;

    const selectedInput = Array.from(picker.querySelectorAll('input')).find(
      (element) => element.dataset.fieldsetIndex === optionIndex && element.checked
    );
    const selectedValue = selectedInput instanceof HTMLInputElement ? selectedInput.value : null;
    const select = picker.querySelector(`select[data-fieldset-index="${optionIndex}"]`);
    const inputs = Array.from(picker.querySelectorAll('input')).filter(
      (input) => input.dataset.fieldsetIndex === optionIndex
    );
    const options = select instanceof HTMLSelectElement ? Array.from(select.options) : inputs;
    const cards = Array.from(this.querySelectorAll('.pc-variation-card'));
    const fullyMapped = options.length > 0 && options.every((option) =>
      cards.some((card) => card.dataset.optionValue === option.value)
    );
    const group = picker.querySelector(`fieldset[data-fieldset-index="${optionIndex}"]`);
    group?.toggleAttribute('data-pc-card-picker', fullyMapped);
    this.dataset.ready = String(options.length > 0);

    cards.forEach((card) => {
      const option = options.find((option) => option.value === card.dataset.optionValue);
      const selected = card.dataset.optionValue === (select?.value ?? selectedValue);
      card.setAttribute('aria-pressed', String(selected));
      card.disabled = !option;
      const status = card.querySelector('[data-pc-card-unavailable]');
      if (status) status.hidden = !option || option.dataset.optionAvailable !== 'false';
    });
  }
}

if (!customElements.get('pawcare-variation-cards')) {
  customElements.define('pawcare-variation-cards', PawCareVariationCards);
}
